import styled, { css } from 'styled-components';
import { CardProps, RowContainerProps } from './types';
import {
	DEFAULT_BG_COLOR,
	MAIN_BG_COLOR,
	SECONDARY_BG_COLOR,
} from 'shared/consts';

export const GridContainer = styled.div<RowContainerProps>`
	display: grid;
	grid-template-columns: ${props => {
		const columnSizes = Array(props.$columns).fill(
			`${props.$columnSize}fr`,
		);

		props.$specificColumnSizes?.forEach(({ index, size }) => {
			if (index >= 1 && index <= props.$columns) {
				columnSizes[index - 1] = `${size}fr`;
			}
		});

		if (props.$trackSize) {
			columnSizes.push(`${props.$trackSize}fr`);
		}

		return columnSizes.join(' ');
	}};
	gap: 16px;
	min-height: ${props => props.$height || 'auto'};
	box-sizing: border-box;
	padding: ${props => props.$padding || '16px 12px'};
	${props =>
		props.$isFixedHeader &&
		css`
			top: -1px;
			position: sticky;
			background: #ffffff;
			border-radius: 10px;
			padding: 8px 16px;
			margin-bottom: 8px;
		`};

	&.is-pinned {
		box-shadow: 0px 10px 20px rgba(87, 124, 240, 0.3);
		transition-duration: 0.7s;
	}
`;

export const Container = styled.div``;

export const Cell = styled.div`
	width: 85%;
	@media (min-width: 1024px) {
		width: 100%;
	}
	align-content: center;
	cursor: pointer;
	word-break: break-word;
`;

export const Rows = styled.div<{ $rowsHeight?: string; $rowsPadding?: string }>`
	overflow: auto;
	height: ${props => props.$rowsHeight || '83vh'};
	padding-right: ${props => props.$rowsPadding || '0px'};
	border-radius: 12px;
`;

export const Card = styled.div<CardProps>`
	border-radius: ${props => props.$borderRadius || '24px'};
	background: ${props =>
		props.$selected ? SECONDARY_BG_COLOR : DEFAULT_BG_COLOR};
	cursor: pointer;
	padding: 0px;
	margin-bottom: ${props => props.$margin || '16px'};
	box-sizing: border-box;
	border-bottom: ${props =>
		(props.$bordered == true) ? `2px solid ${SECONDARY_BG_COLOR}` : 'none'};

	${props =>
		props.$bgColor &&
		css`
			background: ${props.$bgColor};
		`};

	&:last-child {
		border-bottom-left-radius: 12px;
		border-bottom-right-radius: 12px;
	}

  @media (any-hover: hover){
    &:hover {
      .edit-order {
        opacity: 1;
        visibility: visible;
      }
  
      .confirm-order {
        opacity: 1;
        visibility: visible;
      }
    }
  }

	@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		width: fit-content;
	}

	@media only screen and (min-device-width: 820px) and (max-device-width: 820px) {
		width: fit-content;
	}
`;

export const CardGroup = styled.div`
	border-radius: 12px;
	margin-bottom: 12px;
`;

export const PreloaderContainer = styled.div`
	display: flex;
	justify-content: center;
`;

export const NotFound = styled.span`
	display: flex;
	justify-content: center;
	height: 100%;
	align-items: center;
	text-align: center;
`;

export const HiddenContainer = styled.div`
	background: ${MAIN_BG_COLOR};
	display: flex;
	width: 100%;
	height: 20px;
	margin-bottom: -16px;
	position: sticky;
	top: 0px;
`;
